import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter, NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

import { formatDateToDate, getTimezoneOffsetById } from '@atheneum/api/dist/lib'

import Spinner from '@components/spinner'
import '../Sidebar.sass'
import get from 'lodash/get'
import ExpertSidebarStore from '../stores/expertSidebar.store'

class ExpertSidebar extends Component {
  static propTypes = {
    id: PropTypes.number,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object,
    eplId: PropTypes.number
  }

  constructor (props) {
    super(props)
    this.expertSidebarStore = new ExpertSidebarStore()
    this.expertSidebarStore.load(this.props.id, this.props.eplId)
  }

  getIndustry = () => {
    const { staticData } = this.props
    const expert = get(this.expertSidebarStore, 'expert.expert')

    if (!expert) {
      return '-'
    }

    return staticData.getDataFromArray(expert.industryId, 'industries')
  }

  getSubindustries = () => {
    const expert = get(this.expertSidebarStore, 'expert.expert')

    if (!expert) return '-'

    const { subIndustries } = expert
    if (!subIndustries || subIndustries.length < 1) return '-'
    return subIndustries.map(subIndustry => {
      return <p key={subIndustry.id}>{subIndustry.name}</p>
    })
  }

  renderPhones = () => {
    const { staticData } = this.props
    const { address, expert } = this.expertSidebarStore.expert

    if (!address || !expert) return <p>-</p>

    let phones = address.phones
    if (expert.phoneTypeId) {
      phones.push({
        phoneTypeId: expert.phoneTypeId,
        phoneNum: expert.phoneNum,
        isAddedByExpert: true
      })
    }
    if (!address || address.length < 1) return <p>-</p>

    return address.phones.map(phone => {
      let label = staticData.getDataFromArray(phone.phoneTypeId, 'phoneTypes')
      if (phone.isAddedByExpert) {
        label = `${label} (added by expert)`
      }

      return (
        <div className='group' key={phone.id}>
          <span className='sidebar-wrapper__content__label--default'>
            {label}
          </span>
          <p>{get(phone, 'phoneNum')}</p>
        </div>
      )
    })
  }

  renderWorkingExperience = () => {
    const expert = this.expertSidebarStore.expert

    const experiences = get(
      expert,
      'eplExperiences',
      get(expert, 'cv.experiences', [])
    )

    if (!experiences || experiences.length < 1) return <p>-</p>

    return experiences.map(experience => {
      const date = formatDateToDate(
        experience.startDate,
        experience.endDate,
        'MMM YYYY'
      )
      return (
        <li key={experience.id}>
          {experience.position.name}, {experience.company.name} ({date})
        </li>
      )
    })
  }

  renderLanguages = () => {
    const { staticData } = this.props
    const { languages } = this.expertSidebarStore.expert
    if (!languages || languages.length < 1) return <p>-</p>

    return languages.map(language => {
      const proficiency = staticData.getDataFromArray(
        language.languageToUser.languageProficiencyId,
        'languageProficiencies'
      )
      return (
        <li key={language.id}>
          {language.name} ({proficiency})
        </li>
      )
    })
  }

  render () {
    const { expert, loading } = this.expertSidebarStore
    const { closeSidebar } = this.props.sidebarStore

    if (loading) return <Spinner />
    if (!loading && !expert) return null

    return (
      <div>
        <h1 onClick={() => closeSidebar()}>
          <NavLink to={`/expert/${get(expert, 'id')}`}>
            {get(expert, 'title')} {get(expert, 'fullName')}
          </NavLink>
        </h1>

        <div className='group'>
          <p>{get(expert, 'expert.expertCode')}</p>
          <p>{get(expert, 'address.country.name') || '-'}</p>
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Timezone
          </span>
          <p>
            {get(expert, 'address.timezoneId')
              ? getTimezoneOffsetById({
                  id: expert.address.timezoneId,
                  staticData: this.props.staticData,
                  hideIsoCode: true
                })
              : null}
          </p>
        </div>

        <h2>Contact details</h2>

        {this.renderPhones()}

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Email
          </span>
          <p>{expert.email || '-'}</p>
        </div>

        {expert.links[0] ? (
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Professional link
            </span>
            <a
              href={expert.links[0].professionalLinkUrl || '#'}
              target='_blank' rel="noreferrer"
            >
              <p className='ellipsis'>
                {expert.links[0].professionalLinkUrl || '-'}
              </p>
            </a>
          </div>
        ) : null}

        <h2>Industry</h2>
        <div className='group'>
          <p>{this.getIndustry()}</p>
        </div>

        <h2>Sub industry</h2>
        <div className='group'>{this.getSubindustries()}</div>

        <h2>Industry expertise</h2>
        <div className='group'>
          <p
            className='sidebar-wrapper__rich-text rich-text--dark'
            dangerouslySetInnerHTML={{
              __html: expert.expert.industryExpertise || '-'
            }}
          />
        </div>

        <h2>Working experience</h2>
        <div className='group'>
          <ul>{this.renderWorkingExperience()}</ul>
        </div>

        <h2>Languages</h2>
        <div className='group'>
          <ul>{this.renderLanguages()}</ul>
        </div>
      </div>
    )
  }
}

export default withRouter(
  inject('sidebarStore', 'staticData')(observer(ExpertSidebar))
)
